<template>
  <v-dialog
    v-model="dialogStatus"
    scrollable
    max-width="600px"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
    persistent
    v-if="dialogStatus"
  >
    <v-card>
      <v-toolbar max-height="64">
        <v-toolbar-title>{{ $t("theBet") }} </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text style="height: auto" class="pa-2 grey">
        <div id="bet-card">
          <v-card class="white black--text mx-auto pt-1" flat>
            <v-toolbar light flat tile class="flex-grow-0 d-print-none">
              <h3 class="font-weight-black">Nº {{ bet.id }}</h3>
              <div class="flex-grow-1 ml-2">
                <!-- Tag (Não validada) para vizulizar pré-bet, credit 1 -->
                <span
                  class="
                    my-1
                    v-chip
                    theme--light
                    v-size--small
                    red
                    darken-3
                    white--text
                  "
                  v-if="bet.status_bet === '2'"
                  ><span class="v-chip__content"
                    >{{ $t("notValidated") }}
                  </span></span
                >
              </div>
              <div class="pt-1 text-right" style="font-size: 12px">
                {{ bet.date }} <br />
                {{ $gmt() }}
              </div>
            </v-toolbar>
            <v-divider light class="d-print-none"></v-divider>
            <hr class="d-none d-print-block" />
            <v-card-text class="py-2 black--text">
              <v-subheader light class="px-0 d-flex justify-space-between">
                <div>{{ bet.n_events }} {{ $t("selection") }}</div>
                <div>odd</div>
              </v-subheader>
              <div>
                <div
                  v-for="(event, index) in bet.events"
                  :key="event.id_odd"
                  class="d-flex flex-column"
                >
                  <v-divider
                    light
                    v-show="index"
                    class="ml-8 pb-2 d-print-none"
                  ></v-divider>
                  <hr class="d-none d-print-block" />
                  <div class="d-flex pb-2">
                    <div class="pr-4 d-flex justify-center d-print-none">
                      <v-icon light>mdi-circle-medium</v-icon>
                    </div>
                    <div class="flex-grow-1 d-flex flex-column mr-2">
                      <div class="overline">
                        <!-- Torneio - {{ event.tournaments_name }} -->
                        {{ event.category_name }} - {{ event.tournaments_name }}
                      </div>
                      <div class="d-flex justify-space-between">
                        <div class="subtitle-2 text-truncate">
                          <div class="d-flex align-center my-1">
                            <TeamLogo
                              :id_sport="event.id_sport"
                              :id_team="event.id_team_1"
                              :type_size="'medium_logo'"
                              :size="'24px'"
                              class="mr-1"
                            />
                            {{ event.description.split(" X ")[0] }}
                          </div>
                          <div class="d-flex align-center my-1">
                            <TeamLogo
                              :id_sport="event.id_sport"
                              :id_team="event.id_team_2"
                              :type_size="'medium_logo'"
                              :size="'24px'"
                              class="mr-1"
                            />
                            {{ event.description.split(" X ")[1] }}
                          </div>
                        </div>
                        <div>
                          <!-- Statscore -->
                          <div v-if="$permissions().statsCore">
                            <v-btn
                              light
                              fab
                              elevation="0"
                              @click="openTracker(bet.id, event.id_event)"
                            >
                              <v-icon
                                :color="
                                  idEvent == event.id_event && idBet == bet.id
                                    ? 'primary'
                                    : ''
                                "
                                >mdi-soccer-field</v-icon
                              >
                            </v-btn>
                          </div>
                          <!-- / Statscore -->
                        </div>
                      </div>
                      <div class="caption">
                        {{ event.scheduled | dateFormat }} <br />
                        {{ $gmt() }}
                      </div>
                      <!-- Statscore -->
                      <div
                        v-show="!disabledWidget && idEvent == event.id_event"
                      >
                        <div style="background: rgba(0, 0, 0, 0.2)">
                          <div
                            style="max-width: 450px; margin: 0 auto"
                            :id="`widget-${bet.id}-${event.id_event}`"
                          ></div>
                        </div>
                      </div>
                      <div
                        v-if="
                          idEvent == event.id_event &&
                            idBet == bet.id &&
                            unavailable
                        "
                        class="pa-4 text-center caption mb-1"
                        style="
                          background-color: rgba(0, 0, 0, 0.2);
                          border-radius: 4px;
                        "
                      >
                        {{ $t("unavailableTracker") }} 😞
                      </div>
                      <!-- / Statscore -->
                      <div
                        class="text-truncate d-flex flex-column pa-1"
                        style="
                          border: 1px solid #cccccc;
                          border-radius: 8px;
                          width: 100%;
                        "
                      >
                        <div class="d-flex justify-space-between">
                          <div class="font-weight-black">
                            {{
                              $infoTable.outcomes(event.id_outcome).name_outcome
                            }}
                          </div>
                          <div class="font-weight-black text-right">
                            <!-- Pre-Bet = (status_bet = '2')  -->
                            <div
                              :class="
                                bet.status_bet === '2'
                                  ? 'text-decoration-line-through grey--text'
                                  : 'font-weight-black'
                              "
                            >
                              {{ event.factor_event }}
                            </div>
                            <!-- Pre-Bet = (status_bet = '2')  -->
                            <div
                              v-if="bet.status_bet === '2'"
                              class="font-weight-black"
                            >
                              {{ event.odd_price }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-space-between">
                          <div>
                            {{
                              $infoTable.markets(event.id_market).name_market
                            }}
                          </div>
                          <div>
                            <div class="text-right">
                              <div
                                class="font-weight-black"
                                v-html="
                                  $infoTable.conference(
                                    event.result_event,
                                    event.status_event
                                  )
                                "
                              ></div>
                              <v-chip
                                class="ml-2 font-weight-black"
                                color="blue"
                                small
                                v-if="event.live_event == '1'"
                              >
                                {{ $t("live") }}
                              </v-chip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-divider light class="d-print-none"></v-divider>
            <hr class="d-none d-print-block" />
            <v-card-actions>
              <div
                v-if="!$isCreditOnline()"
                class="d-flex align-center justify-center pl-9 pr-3 pt-2"
              >
                <qrcode-vue
                  :value="valueQrcode"
                  :size="sizeQrcode"
                  level="H"
                  renderAs="svg"
                ></qrcode-vue>
              </div>
              <div class="d-flex flex-grow-1 flex-column body-2">
                <div class="d-flex justify-space-between align-center">
                  <div>{{ $t("allOdds") }}</div>
                  <div>
                    <!-- Pre-Bet = (status_bet = '2')  -->
                    <span
                      :class="
                        bet.status_bet === '2'
                          ? 'text-decoration-line-through grey--text'
                          : 'font-weight-black'
                      "
                      >{{ bet.factor_bet }}</span
                    >
                    <!-- Pre-Bet = (status_bet = '2')  -->
                    <span
                      v-if="bet.status_bet === '2'"
                      class="font-weight-black"
                      >&nbsp; {{ current_factor }}</span
                    >
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div>{{ $t("value") }}</div>
                  <div class="font-weight-black">{{ bet.amount }}</div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div>{{ $t("possibleReturn") }}</div>
                  <div>
                    <!-- Apostas Encerradas (result_bet = 2) -->
                    <div v-if="bet.result_bet == 2">
                      <span class="text-decoration-line-through grey--text">{{
                        getPreviousBetValue(bet.amount, bet.factor_bet)
                      }}</span
                      >&nbsp;
                      <span class="font-weight-black">{{ bet.prize }}</span>
                    </div>
                    <div v-else>
                      <!-- Pre-Bet = (status_bet = '2')  -->
                      <span
                        :class="
                          bet.status_bet === '2'
                            ? 'text-decoration-line-through grey--text'
                            : 'font-weight-black'
                        "
                        >{{ bet.prize }}</span
                      >
                      <span
                        v-if="bet.status_bet === '2'"
                        class="font-weight-black"
                        >&nbsp; {{ current_prize }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <div>{{ $t("conference") }}</div>
                  <div
                    class="font-weight-black"
                    v-html="
                      $infoTable.conference(bet.result_bet, bet.status_bet)
                    "
                  ></div>
                </div>
                <div
                  v-if="!$isCreditOnline()"
                  class="d-flex justify-space-between align-center"
                >
                  <div>{{ $t("rewardRedemption") }}</div>
                  <div class="text-right">
                    {{ local_resgate }}
                  </div>
                </div>
              </div>
            </v-card-actions>
            <v-divider light></v-divider>
            <div
              v-if="!$isCreditOnline()"
              class="
                d-flex
                justify-space-between
                align-center
                py-2
                px-2
                d-flex
                flex-column
                body-2
              "
            >
              <div class="overline">hash</div>
              <div
                class="text-center pl-3"
                style="
                  word-wrap: break-word;
                  max-width: 300px;
                  min-width: 280px;
                "
                v-html="handlerHash(bet.hash)"
              ></div>
            </div>
            <v-divider light></v-divider>
          </v-card>
        </div>
      </v-card-text>

      <v-card-actions class="flex-column" v-if="!$isAgent()">
        <v-btn
          v-if="!bet.hideShareBet === true"
          block
          @click="$bet.shareBetTicket(bet.id)"
          depressed
          color="primary"
          class="my-1 mx-0"
        >
          {{ $t("shareCoupon") }}
          <v-icon right>mdi-share-variant</v-icon>
        </v-btn>
        <v-btn
          v-if="
            ($domain() == 'elitexbetcom' ||
              $domain() == 'sys' ||
              $domain() == 'homolog') &&
              !bet.hideShareBet === true
          "
          @click="openCasaDeApostas"
          block
          depressed
          class="my-1 mx-0"
          color="info"
        >
          {{ $t("viewInCasaDeApostas") }}
          <v-icon right>mdi-eye-arrow-right-outline</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
var widget = "";
import QrcodeVue from "qrcode.vue";
import TeamLogo from "@/components/team-logo";
export default {
  name: "bet-dialog-online",
  components: {
    QrcodeVue,
    TeamLogo,
  },
  data: () => ({
    dialog: false,
    disabled: false,
    disabledCancel: false,
    hideBtnCancel: false,
    level: "",
    confirmCancel: false,

    // Card Bet
    sizeQrcode: 80,
    domain: localStorage.getItem("operator"),
    // Statscore:
    disabledWidget: false,
    idBet: "",
    idEvent: "",
    unavailable: false,
  }),
  async beforeDestroy() {
    if (this.$permissions().statsCore) {
      if (widget != "") {
        await widget.destroy();
      }
    }
  },
  created() {
    this.closeDialog();
  },
  computed: {
    maxPrize() {
      return this.$store.state.operators.max_prize;
    },
    dialogStatus() {
      return this.$store.state.dialogBetOnline.status;
    },
    bet() {
      return this.$store.state.dialogBetOnline.value;
    },

    valueQrcode() {
      if (this.bet.hash) {
        return `${this.bet.id}@${this.bet.hash.substring(0, 10)}`;
      } else {
        return false;
      }
    },

    // Current Factor (Only Pre-Bet)
    current_factor() {
      let events = this.bet.events;
      let current = 1;
      for (var i = 0; i < this.bet.n_events; i++) {
        current = current * Number(events[i].odd_price);
      }
      return this.decimalAdjustment(current);
    },
    // Current Prize (Only Pre-Bet)
    current_prize() {
      let current = this.current_factor * this.bet.amount;
      return this.decimalAdjustment(current);
    },
    local_resgate() {
      const agent = this.$store.state.logged.data.nome_vendedor;
      return agent === null ? "Nenhum vinculado" : agent;
    },
  },
  methods: {
    getPreviousBetValue(amount, odd) {
      const prize = amount * odd;

      if (prize > this.maxPrize) {
        return this.decimalAdjustment(this.maxPrize);
      }

      return this.decimalAdjustment(prize);
    },
    closeDialog() {
      this.$store.commit("showBetDialog", {
        status: false,
        value: "",
      });
    },
    handlerHash: function(hash) {
      var firstTen = hash.substring(0, 10);
      var lastHash = hash.substring(10);
      return `<span class="font-weight-bold" style="font-size: 18px">${firstTen}</span>.<span>${lastHash}</span>`;
    },

    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2") || 0.0;
    },

    // Open Live Match Pro (Statscore)
    openTracker(id_bet, id_event) {
      // Reset
      this.unavailable = false;

      // Se o tracker do mesmo id estiver aberto, apenas fecha;
      if (this.idBet == id_bet && this.idEvent == id_event) {
        this.closeTracker();
        this.disabledWidget = true;
        this.idBet = "";
        this.idEvent = "";
        return;
      }

      // Se já existe um tracker aberto, fecha o anterior
      if (this.idEvent != "") {
        this.closeTracker();
        this.unavailable = false;
        this.disabledWidget = true;
      }

      // https://statscore.atlassian.net/wiki/spaces/STW/pages/2917072899/Advanced
      var d = "STATSCOREWidgetsEmbederScript";
      if (!window.document.getElementById(d)) {
        (window.STATSCOREWidgets = {}),
          (window.STATSCOREWidgets.onLoadCallbacks = []),
          (window.STATSCOREWidgets.onLoad = function(d) {
            window.STATSCOREWidgets.onLoadCallbacks.push(d);
          });
        var n = window.document.createElement("script");
        (n.src = "https://wgt-s3-cdn.statscore.com/bundle/Embeder.js"),
          (n.async = !0),
          (n.id = d),
          n.addEventListener("error", function(d) {
            for (
              var n = 0;
              n < window.STATSCOREWidgets.onLoadCallbacks.length;
              n++
            )
              window.STATSCOREWidgets.onLoadCallbacks[n](d);
          }),
          window.document.body.appendChild(n);
      }

      // Hook up when library is loaded and ready to use.
      // You can use this method as many times as necessary - if library
      // is already loaded provided callback will fire immediately
      STATSCOREWidgets.onLoad((err) => {
        if (err) {
          switch (err.type) {
            case "NetworkError":
              this.disabledWidget = true;
              this.unavailable = true;
              break;
            case "BrowserNotSupported":
              this.disabledWidget = true;
              this.unavailable = true;
              break;
          }
          return;
        } else {
          this.disabledWidget = false;
        }

        // Widget will be appended to this HTMLElement.
        //
        // If you are using framework then follow its documentation
        // on how to get DOM Element from your component.
        // Vue.js https://vuejs.org/v2/api/#ref
        // React https://en.reactjs.org/docs/refs-and-the-dom.html
        // Angular https://angular.io/api/core/ElementRef
        const idElement = `widget-${id_bet}-${id_event}`;
        const element = document.getElementById(idElement);
        // Configuration that you should receive from STATSCORE
        const configurationId = "62abb4d3d4bbb801868d7950";
        // Input data for widget type you want to embded
        const inputData = {
          eventId: `m:${id_event}`,
          language: "br",
        };
        const options = {};
        widget = new window.STATSCOREWidgets.WidgetGroup(
          element,
          configurationId,
          inputData,
          options
        );

        // Armazenando o id do evento aberto e id da bet;
        this.idEvent = id_event;
        this.idBet = id_bet;

        widget.on("error", async () => {
          await widget.destroy();
          this.disabledWidget = true;
          this.unavailable = true;
        });
      });
    },
    async closeTracker() {
      await widget.destroy();
    },
    openCasaDeApostas() {
      const bancaId = 1116;
      const betId = this.bet.id;
      const url = `https://casadasapostas.net/bilhete?banca=${bancaId}&codigo=${betId}`;
      window.open(url, "_blank");
    },
  },
  filters: {
    dateFormat: function(val) {
      var date = new Date(val.replace(" ", "T")).toLocaleString();
      return date;
    },
    typeBet: function(val) {
      const type = {
        1: "Simples",
        2: "Dupla",
        3: "Tripla",
      };
      if (val >= 4) return "Múltipla";
      return type[val];
    },
  },
};
</script>
